import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { CreateQuarantinedPartFromNonConformanceReportDto } from "@interfaces/dto/createQuarantinedPartFromNonConformanceReportDto.interface";
import { ResolveQuarantineDto } from "@interfaces/dto/resolveQuarantineDto.interface";
import { Service } from "@services/service";

@Injectable()
export class QuarantinedPartService extends Service {
	constructor(injector: Injector) {
		super("QuarantinedPart", injector);
	}

	// API
	createFromNonConformanceReport(data: CreateQuarantinedPartFromNonConformanceReportDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CreateFromNonConformanceReport`, data);
	}

	getByNonConformanceReportId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByNonConformanceReportId/${id}` );
	}

	getByPartId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByPartId/${id}` );
	}

	getByWorkOrderId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByWorkOrderId/${id}` );
	}

	resolve(data: ResolveQuarantineDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Resolve`, data);
	}
}